import { useInternationalization } from '@progress/kendo-react-intl';

export function useFormatter() {
  const intl = useInternationalization();

  function formatDate(date: Date, format = 'MM/dd/yyyy h:mma'): string {
    return intl.formatDate(date, format);
  }

  function formatDateString(dateString: string, format = 'MM/dd/yyyy h:mma'): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.warn(`Invalid date string provided to formatDateString: ${dateString}`);
      return dateString;
    }

    return intl.formatDate(date, format);
  }

  function formatTime(hours: number, minutes: number, format = 'h:mma'): string {
    const d = new Date();
    d.setHours(hours);
    d.setMinutes(minutes);
    return intl.formatDate(d, format);
  }

  return {
    formatDate,
    formatDateString,
    formatTime,
  };
}
